import {css, Icon, Button} from '@sail/ui/deprecated';
import {cancel} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';
import type {PressEvent} from '@react-types/shared';
import {useTheme} from '../ThemeProvider';

const messages = defineMessages({
  buttonText: {
    id: 'conversations_ui.support_conversations_client.form.closeButton.buttonText',
    description: 'Aria label for the button to dismiss certain forms',
    defaultMessage: 'Close',
  },
});

type Props = {
  onClick: (e: PressEvent) => void;
  dataTestId?: string;
};

export const CloseButton = ({onClick, dataTestId}: Props) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Button
      style={{
        display: 'flex',
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: 'small',
        borderStyle: 'none',
        color: 'secondary',
        backgroundColor: 'surface',
        '&:hover': {
          background: css.value('$color.neutral100'),
        },
        '&:focus': {
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
          outline: theme.focusVisibleOutline,
        },
        padding: 'xsmall',
        bleedTop: 'xsmall',
        bleedRight: 'xsmall',
      }}
      aria-label={intl.formatMessage(messages.buttonText)}
      onPress={onClick}
      data-testid={dataTestId}
    >
      <Icon icon={cancel} size="small" data-testid="close-icon" />
    </Button>
  );
};
